import { COUPON, FARE, PARAM_VALUE_DELIMITER, QUERY_PARAM_ALLOCATOR } from '../../CruiseSearchContext/constants';

export const selectTargetedOffer = ({
	offer,
	updateState,
	setPromotionSelected,
	addToQualifiersSelecting,
	fetchAndUpdateFacetOptions,
}) => {
	const fareCodeQualifier = offer.fareCodes.length
		? `${PARAM_VALUE_DELIMITER}${FARE}${QUERY_PARAM_ALLOCATOR}${offer.fareCodes[0]}`
		: '';
	const constructedQualifierWithFareCode = `${COUPON}${QUERY_PARAM_ALLOCATOR}${offer.couponCode}${fareCodeQualifier}`;

	setPromotionSelected(null);
	updateState({
		targetedOfferSelected: offer,
	});
	addToQualifiersSelecting(constructedQualifierWithFareCode, true, fetchAndUpdateFacetOptions);
};
